export class DevCustomerInfo {
    current: string;
    customers: string[];
}
